module.exports = __webpack_public_path__ + "static/media/loading_BG.f26ab3ac.eb4b6492.gif";